/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto } from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';
import {
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON,
} from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';

/**
 * An invite or a reminder for an event as the admin has written it, to show it the way it will be sent.
 * @export
 * @interface WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto
 */
export interface WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto {
    /**
     * The event the mail is for.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto
     */
    eventId?: number;
    /**
     * The message written by the admin.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto
     */
    message?: string | null;
    /**
     * 
     * @type {WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto}
     * @memberof WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto
     */
    design?: WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto;
    /**
     * True for a reminder, false for an invite.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto
     */
    isReminder?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoFromJSON(json: any): WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto {
    return WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'design': !exists(json, 'design') ? undefined : WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON(json['design']),
        'isReminder': !exists(json, 'isReminder') ? undefined : json['isReminder'],
    };
}

export function WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoToJSON(value?: WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'message': value.message,
        'design': WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON(value.design),
        'isReminder': value.isReminder,
    };
}

